import React from 'react'
import MainLayout from '@components/MainLayout/MainLayout'
import Homepage from '@BidftaStrapi/Pages/Homepage'
import { SectionComponent } from '@BidftaStrapi/Components/types'
import { strapiInstance } from '@utilities/axios/strapi'
import organizePageData from '@BidftaStrapi/utils/organizePageData'
import deepMarkdownSerialization from '@BidftaStrapi/utils/deepMarkdownSerialization'
import { formatPageQuery } from '@BidftaStrapi/utils/queryBuilder'
import SEOData from '@BidftaStrapi/Components/SEOData'
import { SEODataType } from '@BidftaStrapi/Components/SEOData/types'
import dynamicPaths from '@BidftaStrapi/utils/dynamicPaths'
import { StrapiResponseInterface } from '@components/CMS/types'
import { faqSerializedType } from '@components/CMS/FAQ/types'
import { serializeMarkdowns } from '@components/CMS/functions'
import StandAloneFAQ from '@components/CMS/FAQ/StandAloneFAQ'

export const getStaticPaths = dynamicPaths('info')

export async function getStaticProps({
  params: { slug },
}: {
  params: { slug: string }
}) {
  const { data } = await strapiInstance.get(formatPageQuery('info', slug))

  const seo: SEODataType | null = data?.data?.[0]?.landing_page ?? null

  const organizedData = organizePageData(data)

  let serializedFaqs: StrapiResponseInterface<faqSerializedType[]> = {
    data: [],
    meta: {
      page: 1,
      pageSize: 10,
      pageCount: 1,
      total: 0,
    },
  }

  const title = slug
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')

  if (slug === 'bin-store') {
    const faqRes: { data: StrapiResponseInterface<faqSerializedType[]> } =
      await strapiInstance.get(
        `/faqs?populate=*&filters[tags][label][$eq]=${title}`
      )
    serializedFaqs = await serializeMarkdowns(
      'answer',
      faqRes.data as StrapiResponseInterface<faqSerializedType[]>
    )
  }

  return {
    props: {
      homepage: await deepMarkdownSerialization(organizedData),
      seo,
      faqs: serializedFaqs.data || [],
      title,
    },
  }
}

const Campaign = ({
  title,
  homepage,
  seo,
  faqs,
}: {
  title: string
  homepage: SectionComponent[][]
  seo: SEODataType
  faqs: faqSerializedType[]
}) => {
  return (
    <MainLayout
      title="Online Auctions powered by BidFTA"
      previewDescription="Browse through thousands of online auctions powered by BidFTA at a location near you. Find the best deals on products ranging from home goods to electronics."
      ignoreGlobalSEO={Boolean(seo)}
    >
      <SEOData seoData={seo} />
      <div className="xs:rounded-xl hidden ease-in-out duration-200 text-[48px]" />
      <Homepage content={homepage} />
      {faqs && faqs.length > 0 && <StandAloneFAQ title={title} faqs={faqs} />}
    </MainLayout>
  )
}

export default Campaign
